module.exports = __webpack_public_path__ + "img/DSC_0083.94a06a2e.jpg";